import { useState, useEffect } from 'react';
import useQueryParams from './useQueryParams';
import { IPlanCode } from '../Interfaces';

const DEFAULT_PLAN_CODE = IPlanCode.SEASONAL;

function getValidPlanCode(planCode: string | undefined): IPlanCode {
  return planCode === IPlanCode.SEASONAL || planCode === IPlanCode.ANNUAL
    ? planCode
    : DEFAULT_PLAN_CODE;
}

const useSelectedPlan = () => {
  const queryParams = useQueryParams();
  const [selectedPlanCode, setSelectedPlanCode] = useState<IPlanCode>(() =>
    getValidPlanCode(queryParams?.planCode as IPlanCode),
  );

  useEffect(() => {
    setSelectedPlanCode(getValidPlanCode(queryParams?.planCode));
  }, [queryParams]);

  return { selectedPlanCode, setSelectedPlanCode };
};

export default useSelectedPlan;
